/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/jsx-no-bind */
import React, { useEffect, useState } from 'react';
import { Alert } from 'antd';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { ApplicationState } from 'store/combineReducers';
import { Link } from 'react-router-dom';
import { config } from 'core/config';
import dayjs from 'dayjs';

// eslint-disable-next-line no-use-before-define
function ExpireMessage() {
  const { rechangePassword } = config.paths;
  const { user } = useSelector((state: ApplicationState) => state.session);
  const [expireData, setExpireData] = useState(0);
  const [showWarn, setShowWarn] = useState(false);
  const { t } = useTranslation();
  useEffect(() => {
    if (user?.tenant?.passwordTTL !== 0 && user?.passwordUpdatedAt) {
      const expireTime =
        user?.passwordUpdatedAt + user?.tenant?.passwordTTL * 24 * 3600 * 1000;
      setExpireData(expireTime);
      if (expireTime - dayjs().valueOf() < 7 * 24 * 3600 * 1000) {
        setShowWarn(true);
      } else {
        setShowWarn(false);
      }
    }
  }, [user]);
  if (showWarn) {
    return (
      <Alert
        closable
        type="warning"
        className="expirePasswordMessage"
        message={
          <span>
            {t('message.expire.passowrd', {
              time: dayjs(expireData).format('YYYY-MM-DD HH:mm:ss'),
            })}

            <Link
              style={{ marginLeft: 6 }}
              to={{
                pathname: `${rechangePassword}`,
                state: { email: user?.email },
              }}
            >
              {t('message.expire.passowrd.btn.label')}
            </Link>
          </span>
        }
      />
    );
  }
  return null;
}

export default ExpireMessage;
